import {
  PageHeader, Tabs, Tag, Table, Select, Tooltip, Button, Row,
  Col,
} from "antd";
import Column from "antd/lib/table/Column";
import { EditOutlined, PrinterOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import HeaderComponent from "../components/HeaderComponent";
import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import { getTableService } from "../services/table-helper.service";
import AssessSuborndinateInfo from "./AssessSuborndinateInfo";

import Dialog from "../shared/dialog";

import { BrowserRouter as Router, Link, Switch } from "react-router-dom";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import SecondTabScreen from "../components/SecondTabScreen";
import SecondTabForBoards from "../components/SecondTabForBoards";
import SecondBoardsTabs from "../components/SecondBoardsTabs";

const ref = React.createRef();

const { TabPane } = Tabs;
const { Option } = Select;
const pageStyle = `
  @page {
    size:A3 ;
    height:100% !important;
    width:100% !important;
    margin: 20mm;
  }
  @media all {
    .pagebreak {
      display: none;
    }
  }


  @media print {
    size:A4 landscape;
    html, body {
      position::relative;
      height:100% !important;
      width:100% !important;
      margin: 0;
    }

    .pagebreak {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
      overflow: visible; 
    }
  }
`;
const getRowKey = (record) => {
  return `${record.EmpId}`;
};

export default class AssessingSubordinateScreen extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();

    this.state = {
      language: localStorage.getItem("Language"),
      EmpListDatasource: [],
      SectorListDatasource: [],
      Columns: [],
      ColumnsDatasourceTH: [],
      ColumnsDatasourceEN: [],
      ColumnsReport: [],
      ColumnsDataReportTH: [],
      ColumnsDataReportEN: [],
      PositionList: [],
      query: "",
      results: [],
      selectedRowKeys: null,
      visible: false,
      triggprint: true,
      defaultKey: localStorage.getItem("defaultActiveKey"),
    };
    // console.log("this.props", this.props);

    this.dialog = new Dialog();
    // inputRefs = [];

    // setRef = (ref) => {
    //   this.inputRefs.push(ref);
    // };
    // focusInput = (id) => this.inputRefs[id].focus();
  }

  componentWillReceiveProps(nextProps) {
    // console.log("nextProps", nextProps);

    this.setState({ language: nextProps.lang });
    localStorage.setItem("Language", nextProps.lang);
  }

  componentDidMount() {
    // console.log("componentRef", this.inputRef);
    getTableService("44a081c0-4264-4d48-b1c2-730d9e6d19f6").then((result) => {
      var table = [];
      result.forEach((e) => {
        this.state.Columns = e.TableColumn;
      });

      // console.log("this.state.Columns", this.state.Columns);

      this.state.Columns.forEach((e) => {
        // console.log("ColumnKeyTH", e.ColumnKeyTH);
        if (e.ColumnKeyTH == "PrintReport") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,

            render: (e, record) => {
              return (
                <div>
                  {/* <div>เปิดในวันที่ 25/04/2022</div> */}

                  <Link
                    to={{
                      pathname: "/assess-report/ID:" + record.EmpId,
                      state: { record: record },
                    }}
                  >
                    <PrinterOutlined style={{ color: "#5399ff" }} />
                  </Link>
                </div>
              );
            },
          });
        } else if (
          e.ColumnKeyTH !== "EvaluateStatus" &&
          e.ColumnKeyTH !== "PrimaryEvaluteStatus"
          && e.ColumnKeyTH !== "EmpId"
        ) {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyTH == "EmpId") {
          // console.log("in empid")
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.EmpId - b.EmpId,
            sortDirections: ['descend', 'ascend'],

          });

        } else if (e.ColumnKeyTH == "EvaluateStatus") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (e == 3) {
                return (
                  <div>
                    <Tag
                      className="first-level"
                      text-align="center"
                      color="green"
                    >
                      ประเมินตนเองสำเร็จ
                    </Tag>
                  </div>
                );
              } else if (e == 1) {
                return (
                  <div>
                    <Tag className="first-level" color="red">
                      ยังไม่ได้ประเมินตนเอง
                    </Tag>
                  </div>
                );
              } else if (e == 2) {
                return (
                  <div>
                    <Tag className="first-level" color="volcano">
                      กำลังประเมินตนเอง
                    </Tag>
                  </div>
                );
              }
            },
          });
        } else if (e.ColumnKeyTH == "PrimaryEvaluteStatus") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,

            render: (e, record, index) => {
              if (e == 3) {
                // console.log("record", index);
                return (
                  <div>
                    <Tag
                      className="first-level"
                      text-align="center"
                      color="green"
                    >
                      ประเมินผู้ใต้สังกัดสำเร็จ
                    </Tag>
                  </div>
                );
              } else if (e == 1) {
                return (
                  <div>
                    <Tag className="first-level" color="red">
                      ยังไม่ได้ประเมินผู้ใต้สังกัด
                    </Tag>
                    <Tooltip color="geekblue" placement="top" title="ประเมิน">
                      <Link
                        to={{
                          pathname: "/assess-info/ID:" + record.EmpId,
                          state: { record: record },
                        }}
                      >
                        <EditOutlined
                          onClick={() => this.assessSubInfo(record)}
                          style={{ fontSize: "15px", color: "#5399ff" }}
                        />
                      </Link>
                    </Tooltip>
                  </div>
                );
              } else if (e == 2) {
                return (
                  <div>
                    <Tag className="first-level" color="volcano">
                      กำลังประเมินผู้ใต้สังกัด
                    </Tag>
                    <Tooltip color="geekblue" placement="top" title="ประเมิน">
                      <Link
                        to={{
                          pathname: "/assess-info/ID:" + record.EmpId,
                          state: { record: record },
                        }}
                      >
                        <EditOutlined
                          onClick={() => this.assessSubInfo(record)}
                          style={{ fontSize: "15px", color: "#5399ff" }}
                        />
                      </Link>
                    </Tooltip>
                  </div>
                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceTH: this.state.ColumnsDatasourceTH.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });

      // conlumns eng
      this.state.Columns.forEach((e) => {
        // console.log("ColumnKeyTH", e.ColumnKeyEN);
        if (e.ColumnKeyEN == "PrintReport") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,

            render: (e, record) => {
              return (
                <div>
                  {/* <div>
                    Avalaible on 25/04/2022
                  </div> */}
                  <Link
                    to={{
                      pathname: "/assess-report/ID:" + record.EmpId,
                      state: { record: record },
                    }}
                  >
                    <PrinterOutlined style={{ color: "#5399ff" }} />
                  </Link>
                </div>
              );
            },
          });
        } else if (
          e.ColumnKeyEN !== "EvaluateStatus" &&
          e.ColumnKeyEN !== "PrimaryEvaluteStatus" &&
          e.ColumnKeyEN !== "EmpId"
        ) {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,

          });
        } else if (e.ColumnKeyEN == "EmpId") {
          // console.log("in empid")
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.EmpId - b.EmpId,
            sortDirections: ['descend', 'ascend'],

          });
        } else if (e.ColumnKeyEN == "EvaluateStatus") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,

            render: (e, record) => {
              if (e == 3) {
                return (
                  <div>
                    <Tag
                      className="first-level"
                      text-align="center"
                      color="green"
                    >
                      Self-Assessment Completed
                    </Tag>
                  </div>
                );
              } else if (e == 1) {
                return (
                  <div>
                    <Tag className="first-level" color="red">
                      No Self-Assessment record
                    </Tag>
                  </div>
                );
              } else if (e == 2) {
                return (
                  <div>
                    <Tag className="first-level" color="volcano">
                      Self-Assessment in progress
                    </Tag>

                  </div>
                );
              }
            },
          });
        } else if (e.ColumnKeyEN == "PrimaryEvaluteStatus") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,

            render: (e, record, index) => {
              if (e == 3) {
                // console.log("record", index);
                return (
                  <div>
                    <Tag
                      className="first-level"
                      text-align="center"
                      color="green"
                    >
                      Assessment Completed
                    </Tag>
                  </div>
                );
              } else if (e == 1) {
                return (
                  <div>
                    <Tag className="first-level" color="red">
                      No Assessment record
                    </Tag>
                    <Tooltip color="geekblue" placement="top" title="ประเมิน">
                      <Link
                        to={{
                          pathname: "/assess-info/ID:" + record.EmpId,
                          state: { record: record },
                        }}
                      >
                        <EditOutlined
                          onClick={() => this.assessSubInfo(record)}
                          style={{ fontSize: "15px", color: "#5399ff" }}
                        />
                      </Link>
                    </Tooltip>
                  </div>
                );
              } else if (e == 2) {
                return (
                  <div>
                    <Tag className="first-level" color="volcano">
                      Assessment In Progress
                    </Tag>
                    <Tooltip color="geekblue" placement="top" title="ประเมิน">
                      <Link
                        to={{
                          pathname: "/assess-info/ID:" + record.EmpId,
                          state: { record: record },
                        }}
                      >
                        <EditOutlined
                          onClick={() => this.assessSubInfo(record)}
                          style={{ fontSize: "15px", color: "#5399ff" }}
                        />
                      </Link>
                    </Tooltip>
                  </div>

                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceEN: this.state.ColumnsDatasourceEN.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });
    });

    fetch(process.env.REACT_APP_API_URL + "/api/getUnderPrimary", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
        // empid: 772
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result", result);
        result.forEach((element) => {
          this.state.EmpListDatasource = element.EmpList;
          this.state.SectorListDatasource = element.SectorList;
          this.state.results = element.EmpList;
        });
        this.state.EmpListDatasource.forEach((e) => {
          if (this.state.PositionList.length == 0) {
            this.state.PositionList.push({
              PositionNameTH: e.PositionNameTH,
              PositionNameEN: e.PositionNameEN,
            });
          } else {
            this.state.PositionList = this.positionPopper(e.PositionNameTH);
            this.state.PositionList.push({
              PositionNameTH: e.PositionNameTH,
              PositionNameEN: e.PositionNameEN,
            });
          }
          // console.log("EmpListDatasource", e.PositionNameTH);
        });
        this.setState({
          EmpListDatasource: this.state.EmpListDatasource,
          results: this.state.results,
          SectorListDatasource: this.state.SectorListDatasource,
          PositionList: this.state.PositionList,
        });

      });
    // todaytest
    getTableService("pointsofworkreport").then((result) => {
      var table = [];
      result.forEach((e) => {
        this.state.ColumnsReport = e.TableColumn;
      });
      // console.log("this.state.Columns", this.state.ColumnsReport);

      // render thai
      this.state.ColumnsReport.forEach((el) => {
        // console.log("ColumnKeyTH", e.ColumnKeyTH);
        if (
          el.ColumnKeyTH !== "SumSelfCalPoint" &&
          el.ColumnKeyTH !== "SumAssessorCalPoint" &&
          el.ColumnKeyTH !== "EmpId" &&
          el.ColumnKeyTH !== "OrderNo" &&
          el.ColumnKeyTH !== "NameAndLastTH" &&
          el.ColumnKeyTH !== "PositionNameTH" &&
          el.ColumnKeyTH !== "SectorNameTH"
        ) {
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            className: 'SubRepHead SubRepColumn SubRepTD HeadSort',
          });
        } else if (el.ColumnKeyTH == "NameAndLastTH") {
          // console.log("in OrderNo");
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            width: '10px',
            className: 'SubRepHead SubRepColumn SubRepTD HeadSort HeadersForReport TdForBoard',

            render: (e, record, index) => {
              return (
                <div>
                  {record.FirstNameTH} {record.LastNameTH}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "SectorNameTH") {
          // console.log("in OrderNo");
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            className: 'SubRepHead SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',

            render: (e, record, index) => {
              return (
                <div>
                  {record.SectorNameTH}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "PositionNameTH") {
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            // className: 'reporthead reportcolumn',
            className: 'SubRepHead SubRepPositionCol SubRepPositionTD HeadSort HeadersForReport TdForBoard',

            render: (e, record, index) => {
              return (
                <div>
                  {record.PositionNameTH}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "OrderNo") {
          // console.log("in OrderNo");
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            // className: 'reporthead reportcolumn reporttd HeadSort',
            className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',


            render: (e, record, index) => {
              return (
                <div>
                  {index + 1}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "EmpId") {
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            className: 'reporthead reportcolumn reporttd HeadSort',
            defaultSortOrder: "descend",
            sorter: (a, b) => a.EmpId - b.EmpId,
            sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "SumSelfCalPoint") {
          this.state.ColumnsDataReportTH.push({
            title: 'คะแนนการประเมิน',
            dataIndex: 'คะแนนการประเมิน',
            OrderBy: el.ColumnOrder,
            className: 'reporthead reportcolumn reporttd HeadSort',
            children: [{
              title: 'ประเมินตนเอง',
              dataIndex: 'SumSelfCalPoint',
              className: 'reporthead reportcolumn reporttd HeadSort',
              OrderBy: el.ColumnOrder,
              render: (e, record) => {
                if (record.EvaluateStatus == 1) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else if (record.EvaluateStatus == 2) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <p> {e} </p>
                    </div>
                  );
                }
              },
            },

            ],


          });
        } else if (el.ColumnKeyTH == "SumAssessorCalPoint") {
          // console.log('dddddddddddddddddddd', this.state.ColumnsDataReportTH[5].children)
          this.state.ColumnsDataReportTH[5].children.push({
            title: 'ผู้บังคับบัญชาประเมิน',
            dataIndex: 'SumAssessorCalPoint',
            className: 'reporthead reportcolumn reporttd HeadSort',
            OrderBy: el.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                console.log("e in PrimaryEvaluteStatus", e);
                console.log("record in PrimaryEvaluteStatus", record);
                return (
                  <div>
                    <p> </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          })
          // {
          //   title: 'ผู้บังคับบัญชาประเมิน',
          //   dataIndex: 'SumAssessorCalPoint',
          //   className: 'reporthead reportcolumn reporttd',
          //   OrderBy: el.ColumnOrder,
          //   render: (e, record) => {
          //     if (record.EvaluateStatus == 1) {
          //       console.log('e',e)
          //       console.log('record',record)
          //       return (
          //         <div> 
          //           <p> ยังไม่ได้ประเมินตนเอง </p>
          //         </div>
          //       );
          //     } else if (record.EvaluateStatus == 2) {
          //       return (
          //         <div>
          //           <p> กำลังประเมินตนเอง </p>
          //         </div>
          //       );
          //     } else {
          //       return (
          //         <div>
          //           <p> {e} </p>
          //         </div>
          //       );
          //     }
          //   },
          // }
        }
      });

      this.setState({
        ColumnsDataReportTH: this.state.ColumnsDataReportTH.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });

      //render en
      this.state.ColumnsReport.forEach((el) => {
        // console.log("ColumnKeyEN", e.ColumnKeyEN);
        if (
          el.ColumnKeyEN !== "SumSelfCalPoint" &&
          el.ColumnKeyEN !== "SumAssessorCalPoint" &&
          el.ColumnKeyEN !== "EmpId" &&
          el.ColumnKeyEN !== "OrderNo" &&
          el.ColumnKeyEN !== "NameAndLastEN" &&
          el.ColumnKeyEN !== "PositionNameEN" &&
          el.ColumnKeyEN !== "SectorNameEN"
        ) {
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            className: 'SubRepHead SubRepColumn SubRepTD HeadSort',
          });
        } else if (el.ColumnKeyEN == "NameAndLastEN") {
          // console.log("in OrderNo");
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            width: '10px',
            className: 'SubRepHead SubRepColumn SubRepTD HeadSort HeadersForReport TdForBoard',

            render: (e, record, index) => {
              return (
                <div>
                  {record.FirstNameEN} {record.LastNameEN}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "SectorNameEN") {
          // console.log("in OrderNo");
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            className: 'SubRepHead SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',
            render: (e, record, index) => {
              return (
                <div>
                  {record.SectorNameEN}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "PositionNameEN") {
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            // className: 'reporthead reportcolumn',
            className: 'SubRepHead SubRepPositionCol SubRepPositionTD HeadSort HeadersForReport TdForBoard',
            render: (e, record, index) => {
              return (
                <div>
                  {record.PositionNameEN}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "OrderNo") {
          // console.log("in OrderNo");
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            // className: 'reporthead reportcolumn reporttd HeadSort',
            className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',

            render: (e, record, index) => {
              return (
                <div>
                  {index + 1}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "EmpId") {
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            className: 'reporthead reportcolumn reporttd HeadSort',
            defaultSortOrder: "descend",
            sorter: (a, b) => a.EmpId - b.EmpId,
            sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "SumSelfCalPoint") {
          this.state.ColumnsDataReportEN.push({
            title: 'Points of Work Performance',
            dataIndex: 'Points of Work Performance',
            OrderBy: el.ColumnOrder,
            className: 'reporthead reportcolumn reporttd HeadSort',
            children: [{
              title: 'Self - Assessment',
              dataIndex: 'SumSelfCalPoint',
              className: 'reporthead reportcolumn reporttd HeadSort HeadersLongRep',
              OrderBy: el.ColumnOrder,
              render: (e, record) => {
                if (record.EvaluateStatus == 1) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else if (record.EvaluateStatus == 2) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <p> {e} </p>
                    </div>
                  );
                }
              },
            },

            ],


          });
        } else if (el.ColumnKeyEN == "SumAssessorCalPoint") {
          // console.log('dddddddddddddddddddd', this.state.ColumnsDataReportEN[5].children)
          this.state.ColumnsDataReportEN[5].children.push({
            title: 'Assessment by Supervisor',
            dataIndex: 'SumAssessorCalPoint',
            className: 'reporthead reportcolumn reporttd HeadSort HeadersLongRep',
            OrderBy: el.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                console.log("e in PrimaryEvaluteStatus", e);
                console.log("record in PrimaryEvaluteStatus", record);
                return (
                  <div>
                    <p> </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          })

        }
      });

      this.setState({
        ColumnsDataReportEN: this.state.ColumnsDataReportEN.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });
    });
  }

  assessSubInfo(record) {
    // console.log("record", record);
    // console.log("record.EmpId", record.EmpId);
  }

  positionPopper(positionName) {
    var tempDup = [];
    tempDup = this.state.PositionList.filter((e) => {
      return positionName !== e.PositionNameTH;
    });
    return tempDup;
  }

  changeTabs(key) { }

  getSearchResults = (query) => {
    const allData = this.state.results;
    const dataToShow = [];
    allData.forEach((item) => {
      // console.log("item", item);
      const searchString = query;
      if (item.PositionNameTH == searchString) {
        dataToShow.push(item);
      }
    });
    this.setState({
      EmpListDatasource: dataToShow,
    });
  };

  handlePositionChange = (value) => {
    // console.log("handlePositionChange", value);
    this.setState(
      {
        query: value,
      },
      () => {
        if (this.state.query && this.state.query.length > 0) {
          // console.log("this.state.query", this.state.query);
          this.getSearchResults(this.state.query);
        } else {
          this.setState({
            EmpListDatasource: this.state.results,
          });
        }
      }
    );
  };

  setRowKey(record) {
    const selectedRowKey = getRowKey(record);
    // console.log(selectedRowKey, typeof selectedRowKey);
    this.setState({ selectedRowKey });
  }

  renderContentTH() {
    const { EmpListDatasource, ColumnsDatasourceTH, PositionList, ColumnsDataReportTH, SectorListDatasource } = this.state;
    var tempSector = SectorListDatasource.filter((e) => {
      return e.SectorId == this.state.sectorTH;
    });
    return (
      <div>
        <PageHeader
          className="site-page-header"
          onBack={() => window.history.back()}
          title="ประเมินผู้ใต้สังกัด"
        />

        <Tabs
          defaultActiveKey={this.state.defaultKey}
          onChange={(e) => this.changeTabs(e)}
          visible
          centered
        >
          <TabPane tab="ขั้นที่ 1 ประเมินผลการปฎิบัติงานผู้ใต้สังกัด" key="1">
            <div className="select-style">
              <label style={{ paddingRight: "15px" }}>
                เลือกตามตำแหน่งงาน:
              </label>
              <Select
                placeholder=""
                bordered
                defaultValue={"ทั้งหมด"}
                onChange={(e) => this.handlePositionChange(e)}
                //RUN 04202022 แก้ไขให้เป็น em เพื่อให้ไม่เคลื่อนเมื่อทำการเลือกตัวเลือกที่มีข้อความยาว
                style={{ width: '20em' }}
              >
                <Option value={null}
                  style={{ textAlign: 'center' }}


                > ทั้งหมด </Option>
                {PositionList.map((position) => (
                  <Option value={position.PositionNameTH}
                    style={{ textAlign: 'center' }}

                  >
                    {position.PositionNameTH}
                  </Option>
                ))}
              </Select>

            </div>
            <div>
              <div className="tab-centered ">
                <div
                  style={{ float: "right" }}
                >

                  <ReactToPrint
                    pageStyle={pageStyle}
                    trigger={() => {
                      return (
                        <div
                          style={{
                            textAlign: "center",
                            marginBlock: 5,

                          }}
                        >
                          {/* <Button hidden type="primary">พิมพ์รายงาน</Button> */}
                          {/* hidden for now */}
                          <Button type="primary">พิมพ์รายงาน</Button>

                        </div>
                      );
                    }}
                    content={() => this.componentRef}
                  />
                  <div
                    style={{ display: 'none' }}
                  >
                    <div ref={(el) => (this.componentRef = el)}>
                      <div style={{ textAlign: "center", marginTop: 100, marginBottom: 100 }}>
                        <h3 style={{ fontSize: '2.5em' }}>
                          คะแนนการประเมินการปฏิบัติงานประจำปีการศึกษา 2564
                        </h3>
                        <h3> {tempSector.map((e) => e.SectorNameTH)}</h3>
                      </div>
                      <Row style={{ marginBottom: .1, marginTop: .1 }}>

                        <Col >
                          <div >
                            <label style={{ paddingRight: 15 }}>
                              <h3 style={{ fontSize: '2em' }}> คณะวิชา/หน่วยงาน: {localStorage.getItem('DepartmentTH')} </h3>
                            </label>
                          </div>
                        </Col>

                      </Row>
                      <Row style={{ marginBottom: .1, marginTop: .1 }}>


                        <Col span={12}>
                          <div >
                            <label style={{ paddingRight: 15, }}>
                              <h3 style={{ fontSize: '2em' }}> จำนวนบุคลากรในสังกัด {EmpListDatasource.length} คน</h3>

                            </label>
                          </div>
                        </Col>

                      </Row>
                      <div className="tab-centered ">
                        <Table
                          dataSource={EmpListDatasource}
                          columns={ColumnsDataReportTH}
                          pagination={false}
                        >
                          <Column
                          />
                        </Table>
                      </div>

                      <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <div style={{ textAlign: "center", marginTop: 25 }}>
                          <p style={{ fontSize: '2em' }}> ลงชื่อ _________________________________</p>
                          <p style={{ fontSize: '2em' }}>
                            {" "}
                            {"( " +
                              localStorage.getItem("TitleTH") +
                              " " +
                              localStorage.getItem("FirstNameTH") +
                              " " +
                              localStorage.getItem("LastNameTH") +
                              " )"}
                          </p>
                          <p style={{ fontSize: '2em' }}> ตำแหน่ง _______________________________</p>
                          <p style={{ fontSize: '2em' }}> วันที่ _________________</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Table
                  dataSource={EmpListDatasource}
                  columns={ColumnsDatasourceTH}
                  rowKey={(record) => getRowKey(record)}
                  rowClassName={(record) =>
                    getRowKey(record) === this.state.selectedRowKey
                      ? "highlighted-selection"
                      : ""
                  }
                  onRow={(record) => {
                    return {
                      onClick: () => {
                        this.setState({ visible: true });
                        this.setRowKey(record);
                        localStorage.setItem("defaultActiveKey", 1);
                      },
                    };
                  }}
                  pagination={false}
                >
                  <Column ></Column>
                </Table>
              </div>
            </div>
          </TabPane>

          {localStorage.getItem("PositionID") == "02" ||
            localStorage.getItem("PositionID") == "03"
            || localStorage.getItem("PositionID") == "01"
            ? (
              <TabPane tab="ขั้นที่ 2 พิจารณาระดับผลการปฎิบัติงาน" key="2">
                {/* <SecondBoardsTabs /> */}
                <SecondTabForBoards propsName={this.props} />
              </TabPane>
            ) : (
              localStorage.getItem("PositionID") !== "10" &&
              
              localStorage.getItem("PositionID") !== "11" && (
                <TabPane tab="ขั้นที่ 2 พิจารณาระดับผลการปฎิบัติงาน" key="2">
                  <SecondTabScreen propsName={this.props} />
                </TabPane>
              )
            )}

          {/* { localStorage.getItem("PositionID") !== "10" &&
            localStorage.getItem("PositionID") !== "11" && (
              <TabPane tab="ขั้นที่ 2 พิจารณาระดับผลการปฎิบัติงาน" key="2">
                <SecondTabScreen propsName={this.props} />
              </TabPane>
            )}
             */}
        </Tabs>
      </div>
    );
  }

  renderContentEN() {
    const { EmpListDatasource, ColumnsDatasourceEN, ColumnsDataReportEN, PositionList, SectorListDatasource } = this.state;
    var tempSector = SectorListDatasource.filter((e) => {
      return e.SectorId == this.state.sectorTH;
    });
    return (
      <div>
        <PageHeader
          className="site-page-header"
          onBack={() => window.history.back()}
          title="Assessing Subordinate"
        />

        <Tabs
          defaultActiveKey={this.state.defaultKey}
          onChange={(e) => this.changeTabs(e)}
          visible
          centered
          {...this.props}
        >
          <TabPane tab="Step 1: Evaluate Subordinate Performance" key="1">
            <div className="select-style">
              <label style={{ paddingRight: "15px" }}>Choose a Position:</label>
              <Select
                placeholder=""
                bordered

                defaultValue={"All"}
                onChange={(e) => this.handlePositionChange(e)}
                style={{ width: '20em' }}


              >
                <Option value={null}
                  style={{ textAlign: 'center' }}
                > All </Option>
                {PositionList.map((position) => (
                  <Option value={position.PositionNameEN}
                    style={{ textAlign: 'center' }}
                  >
                    {position.PositionNameEN}
                  </Option>
                ))}
              </Select>
            </div>

            <div className="tab-centered">

              <div
                style={{ float: "right" }}
              >

                <ReactToPrint
                  pageStyle={pageStyle}
                  trigger={() => {
                    return (
                      <div
                        style={{
                          textAlign: "center",
                          marginBlock: 5,

                        }}
                      >
                        {/* <Button hidden type="primary">พิมพ์รายงาน</Button> */}
                        {/* hidden for now */}
                        <Button type="primary">Print Report</Button>

                      </div>
                    );
                  }}
                  content={() => this.componentRef}
                />
                <div
                  style={{ display: 'none' }}
                >
                  <div ref={(el) => (this.componentRef = el)}>
                    <div style={{ textAlign: "center", marginTop: 100, marginBottom: 100 }}>
                      <h3 style={{ fontSize: '2.5em' }}>
                        Points of Work Performance for Academic Year 2021
                      </h3>
                      <h3> {tempSector.map((e) => e.SectorNameEN)}</h3>
                    </div>
                    <Row style={{ marginBottom: .1, marginTop: .1 }}>

                      <Col >
                        <div >
                          <label style={{ paddingRight: 15 }}>
                            <h3 style={{ fontSize: '2em' }}> Faculty/Department: {localStorage.getItem('DepartmentEN')} </h3>
                          </label>
                        </div>
                      </Col>

                    </Row>
                    <Row style={{ marginBottom: .1, marginTop: .1 }}>


                      <Col span={12}>
                        <div >
                          <label style={{ paddingRight: 15, }}>
                            <h3 style={{ fontSize: '2em' }}> Amount of people {EmpListDatasource.length} คน</h3>

                          </label>
                        </div>
                      </Col>

                    </Row>
                    <div className="tab-centered ">
                      <Table
                        dataSource={EmpListDatasource}
                        columns={ColumnsDataReportEN}
                        pagination={false}
                      >
                        <Column
                        />
                      </Table>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <div style={{ textAlign: "center", marginTop: 25 }}>
                        <p style={{ fontSize: '2em' }}> Signarture _________________________________</p>
                        <p style={{ fontSize: '2em' }}>
                          {" "}
                          {"( " +
                            localStorage.getItem("TitleEN") +
                            " " +
                            localStorage.getItem("FirstNameEN") +
                            " " +
                            localStorage.getItem("LastNameEN") +
                            " )"}
                        </p>
                        <p style={{ fontSize: '2em' }}> Position _______________________________</p>
                        <p style={{ fontSize: '2em' }}> Date _________________</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Table
                dataSource={EmpListDatasource}
                columns={ColumnsDatasourceEN}
                rowKey={(record) => getRowKey(record)}
                rowClassName={(record) =>
                  getRowKey(record) === this.state.selectedRowKey
                    ? "highlighted-selection"
                    : ""
                }
                onRow={(record) => {
                  return {
                    onClick: () => {
                      this.setState({ visible: true });
                      this.setRowKey(record);
                    },
                  };
                }}
                pagination={false}
              >
                <Column></Column>
              </Table>
            </div>
          </TabPane>



          {localStorage.getItem("PositionID") == "02" ||
            localStorage.getItem("PositionID") == "03"
            || localStorage.getItem("PositionID") == "04"
            || localStorage.getItem("PositionID") == "01"
            ? (
              <TabPane tab="Step 2: Assess a Result of Work Performance" key="2">
                <SecondTabForBoards propsName={this.props} />
              </TabPane>
            ) : (
              localStorage.getItem("PositionID") !== "10" &&
              localStorage.getItem("PositionID") !== "11" && (
                <TabPane tab="Step 2: Assess a Result of Work Performance" key="2">
                  <SecondTabScreen propsName={this.props} />
                </TabPane>
              )
            )}

          {/* {localStorage.getItem("PositionID") !== "10" &&
            localStorage.getItem("PositionID") !== "11" && (
              <TabPane tab="Step 2: Assess a Result of Work Performance" key="2">
                <SecondTabScreen propsName={this.props} />
              </TabPane>
            )} */}
        </Tabs>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.language == "TH"
          ? this.renderContentTH()
          : this.renderContentEN()}
      </div>
    );
  }
}
